
import { useRef, useState } from 'react';
import { Button, Col, Form, Row, Popover } from 'react-bootstrap';
import Select from 'react-select';

import { ModalFiltrosComponent, PopoverFiltrosComponent } from './components';

import InputDataCombo from "../../../Componentes/InputDataCombo";
import ComboIntegracaoSistemas from '../../../Componentes/ComboIntegracaoSistemas';
import ComboEmpresasUsuarios from '../../../Componentes/ComboEmpresasUsuarios';
import ComboEmpresas from '../../../Componentes/ComboEmpresas';
import { intersectObject } from '../../../Funcoes';
import ComboFuncionarios from '../../../Componentes/ComboFuncionarios';

export default function ModalFiltros({
    elemento,
    mostrar,
    alterarMostrar,
    parametros,
    alterarParametros
}){

    // prepara
    let filtrosPadrao = {
        descricao: null,
        origem: null,
        idsIntegracaoSistema: null,
        dataInicio: null,
        dataFinal: null,
        idUsuario: null,
        idEmpresa: null,
        idFuncionario: null
    };

    // verifica se o id da empresa não é um objeto
    if(parametros.idEmpresa && typeof parametros.idEmpresa !== 'object'){

        // remove o id empresa
        delete filtrosPadrao.idEmpresa;
    }

    // estados
    const [ filtros, alterarFiltros ] = useState({
        ...filtrosPadrao
    });
    const refs = {
        dataInicioCol: useRef(null),
        dataFinalCol: useRef(null)
    };

    // prepara filtro de evento
    const evento = [
        {label: 'Cadastro', value: 'cadastrar'},
        {label: 'Alteração', value: 'alterar'},
        {label: 'Exclusão', value: 'deletar'},
        {label: 'Outros', value: 'outros'}
    ];

    // prepara filtro de origem
    const origem = [
        {label: 'Interno', value: 'interno'},
        {label: 'Financeiro', value: 'financeiro'},
        {label: 'GeoGrid', value: 'geogrid'}
    ];


    // função para limpar os filtros
    function limparFiltros(){

        // prepara
        let filtrosAlterar = {...filtros};

        // percorre filtros
        Object.keys(filtros).map((filtro) => {

            // limpa
            filtrosAlterar[filtro] = null;

        });

        // altera
        alterarFiltros({...filtrosAlterar});
        // alterarParametros({...parametros, ...filtrosAlterar});

    }

    // função para cancelar (sair sem aplicar)
    function cancelar(){

        // fecha
        alterarMostrar(false);

        // altera os filtros para o estado inicial
        let filtrosAlterar = {...filtros};

        // percorre
        Object.keys(filtros).map((filtro) => {

            // altera
            filtrosAlterar[filtro] = parametros[filtro] ?? null;
        });

        // altera os filtros
        alterarFiltros(filtrosAlterar);

    }

    return <ModalFiltrosComponent
        show={mostrar}
        target={elemento}
        placement="bottom"
        rootClose
        onHide={() => {
            cancelar();
        }}
    >
        <PopoverFiltrosComponent
            size={'sm'}
            title={'Filtros'}
        >
            <Popover.Title>
                Filtros
                <Button
                    size="sm"
                    name="botao-limpar"
                    onClick={() => {

                        // limpa filtros
                        limparFiltros();
                    }}
                >
                    Limpar
                </Button>
            </Popover.Title>
            <Popover.Content>
                <Row>
                    <Col>
                        <Form.Label>Pesquisa</Form.Label>
                        <Form.Control 
                            value={filtros.descricao || ''}
                            onChange={e => {

                                // altera
                                alterarFiltros({...filtros, descricao: e.target.value});
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Data</Form.Label>
                        <Row>
                            <Col className='position-relative' ref={refs.dataInicioCol}>
                                {refs.dataInicioCol.current && <InputDataCombo
                                    size="sm"
                                    placeholder="A partir de"
                                    data={filtros.dataInicio}
                                    onChange={(novaData) => {
                                        alterarFiltros({...filtros, dataInicio: novaData})
                                    }}
                                    options={{
                                        appendTo: refs.dataInicioCol.current
                                    }}
                                />}
                            </Col>
                            <Col className='position-relative' ref={refs.dataFinalCol}>
                                {refs.dataFinalCol.current && <InputDataCombo
                                    size="sm"
                                    placeholder="Até"
                                    data={filtros.dataFinal}
                                    onChange={(novaData) => {
                                        alterarFiltros({...filtros, dataFinal: novaData})
                                    }}
                                    options={{
                                        appendTo: refs.dataFinalCol.current
                                    }}
                                />}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Evento</Form.Label>
                        <Select
                            className="select-ficha"
                            size="sm"
                            options={evento}
                            value={evento.filter((s) => filtros.evento && filtros.evento.includes(s.value))}
                            isMulti={true}
                            placeholder='Sem filtro'
                            onChange={(opcoes) => {
                                
                                // altera os filtros selecionados
                                alterarFiltros({
                                    ...filtros,
                                    evento: (
                                        opcoes ? opcoes.map((s) => s.value) : null
                                    )
                                });
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Origem</Form.Label>
                        <Select
                            className="select-ficha"
                            size="sm"
                            options={origem}
                            value={origem.filter((s) => filtros.origem && filtros.origem.includes(s.value))}
                            isMulti={true}
                            placeholder='Sem filtro'
                            onChange={(opcoes) => {
                                
                                // altera os filtros selecionados
                                alterarFiltros({
                                    ...filtros,
                                    origem: (
                                        opcoes ? opcoes.map((s) => s.value) : null
                                    )
                                });
                            }}
                        />
                    </Col>
                </Row>
                {
                    (parametros.idEmpresa && typeof parametros.idEmpresa !== 'object') ? <></> : <Row>
                    <Col>
                        <Form.Label>Por empresa</Form.Label>
                        <ComboEmpresas
                            className="select-ficha"
                            ids={filtros.idEmpresa ?? []}
                            alterou={(ids) => {
                                
                                // altera os filtros selecionados
                                alterarFiltros({
                                    ...filtros,
                                    idEmpresa: ids
                                });
                            }}
                        />
                    </Col>
                </Row>}
                <Row>
                    <Col>
                        <Form.Label>Por usuário</Form.Label>
                        <ComboEmpresasUsuarios
                            className="select-ficha"
                            ids={filtros.idUsuario ?? []}
                            alterou={(ids) => {
                                
                                // altera os filtros selecionados
                                alterarFiltros({
                                    ...filtros,
                                    idUsuario: ids
                                });
                            }}
                            filtros={{
                                idEmpresa: (parametros.idEmpresa && typeof parametros.idEmpresa !== 'object') ? parametros.idEmpresa : null
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label>Por funcionário</Form.Label>
                        <ComboFuncionarios
                            className="select-ficha"
                            isMulti={true}
                            valor={filtros.idFuncionario ?? []}
                            aoAlterar={(ids) => {
                                
                                // altera os filtros selecionados
                                alterarFiltros({
                                    ...filtros,
                                    idFuncionario: ids
                                });
                            }}
                        />
                    </Col>
                </Row>
                
                <div className='footer'>
                    <Button
                        size="sm"
                        variant={'light'}
                        onClick={() => {

                            // cancela
                            cancelar();
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        size="sm"
                        variant={'success'}
                        onClick={() => {

                            // altera os parâmetros
                            alterarParametros({...parametros, ...filtros, pagina: 1});
                        }}
                    >
                        Aplicar
                    </Button>
                </div>
            </Popover.Content>
        </PopoverFiltrosComponent>
    </ModalFiltrosComponent>
    
}